<template>
    <div class="com-contact">
        <div class="com-contact-wrapper container">		
            <div class="com-title">联系我们<label>contact Us</label></div>	
            <ul class="com-contact__items">
                <img src="@/assets/code.jpg">	
                <li class="com-contact__item wx">扫码关注公众号”有寄有你“</li>
                <li class="com-contact__item">免费合作热线<br><a href="tel:01213188285">01213188285</a></li>	
                <li class="com-contact__item">邮箱：service@thenetbridge.com</li>
                <!-- <li class="com-contact__item">地址：C/O Wong Lange & Co, 29-30, Frith Street, London, United Kingdom, W1D 5LG</li> -->
            </ul>
        </div>	
    </div>
</template>

<script>
export default {
    name: 'site-contact'
}
</script>

<style lang="less" scoped>
    .com-contact {
        background: url('~@/assets/bk-2.jpg') no-repeat center bottom #eef2f5;
        text-align: center;
        &-wrapper {
            padding: 0 .7rem;
            box-sizing: border-box;
        }
        img {
            width: 100px;
            border: 4px solid #fff;
        }
        .wx {
            color: #6c81a9;
            margin-bottom: .5rem;
        }
        .com-title {
            padding: .5rem 0;
        }
        &__item {
            margin-bottom: .1rem;
            font-size: .25rem;
            line-height: 1.44;
            a {
                font-size: .5rem;
                color: #3abb69;
            }
        }
    }
</style>

